import { Box } from 'grid'
import {
  Dialog,
  DialogType,
  IDialogProps,
  PrimaryButton,
  Stack,
} from 'office-ui-fabric-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from 'theme'

export type ConfirmDeleteDialogProps = Omit<IDialogProps, 'modalProps'> & {
  titleText: string | undefined
}

export const MailingDialog: React.FunctionComponent<
  ConfirmDeleteDialogProps
> = ({ dialogContentProps, titleText, ...props }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Dialog
      dialogContentProps={{
        type: DialogType.normal,
        title: titleText || 'Unterschiedliche Hotels',
        ...dialogContentProps,
      }}
      {...props}
      modalProps={{
        isBlocking: true,
        styles: { main: { maxWidth: 450 } },
      }}
    >
      <Box mt={2}>
        <Stack
          tokens={{ childrenGap: theme.space![1] }}
          horizontal={true}
          horizontalAlign="end"
        >
          <Stack.Item>
            <PrimaryButton onClick={props.onDismiss as any}>
              {t('action.ok')}
            </PrimaryButton>
          </Stack.Item>
        </Stack>
      </Box>
    </Dialog>
  )
}

export default MailingDialog
